import { ViewsAction, ViewsActionType } from './Views.action-types';
import { IViewsState } from './Views.types';

const initialState: IViewsState = {
  views: null,
  isLoading: false,
  errorMessage: null,
};

export function viewsReducer(state: IViewsState = initialState, action: ViewsAction): IViewsState {
  switch (action.type) {
    case ViewsActionType.REQUEST_VIEWS:
      return {
        ...state,
        isLoading: true,
      };
    case ViewsActionType.RECEIVE_VIEWS:
      return {
        ...state,
        isLoading: false,
        errorMessage: null,
        views: action.views,
      };
    default:
      return state;
  }
}
